import { MissionsButton } from "ui/components/modals/MissionsModal/components/MissionsButton";
import { StoriesButton } from "ui/components/modals/StoriesModal/components/StoriesButton";
import { SettingsButton } from "../SettingsButton";
import { DesignButton } from "../DesignButton";
import { useSelector } from "react-redux";
import { UIRootState } from "ui/store";

export const MobileBottomTabPanel = ({ className = "" }: { className?: string }) => {

  const settingsOpen = useSelector((state: UIRootState) => state.gameUI.modals.settingsModal.isOpen);
  const designOpen = useSelector((state: UIRootState) => state.gameUI.modals.designModal.isOpen);
  const missionsOpen = useSelector((state: UIRootState) => state.gameUI.modals.missionsModal.isOpen);
  const storiesOpen = useSelector((state: UIRootState) => state.gameUI.modals.storiesModal.isOpen);
  const buttons = useSelector((state: UIRootState) => state.gameUI.buttons);

  const handleButtonClick = (buttonKey: string, data?: any) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    document.dispatchEvent(new CustomEvent('ui-button-click', {
      detail: { buttonKey, data }
    }));
  };

  return (
    <div className={`mobile-bottom-tab-panel flex-row justify-content-between align-items-center${className.length ? ` ${className}` : ''}`}>
        <SettingsButton onClick={() => handleButtonClick('settings')} type="secondary" isSelected={settingsOpen} />
        <DesignButton onClick={() => handleButtonClick('design')} type="secondary" isSelected={designOpen} />
        <MissionsButton onClick={() => handleButtonClick('missions')} type="secondary" isSelected={missionsOpen} />
        <StoriesButton onClick={() => handleButtonClick('stories')} type="secondary" isSelected={storiesOpen} disabled={buttons.storiesDisabled} />
    </div>
  );
};